import { useParams, Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { CONTACT } from "../config";

const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    intro: "How we handle the little information you share with us.",
    sections: [
      { h: "What we collect", b: `When you submit our contact or enquiry form, we collect your name, email address, phone number (if provided) and your message. When you order via WhatsApp or a marketplace, those platforms' own privacy policies apply.` },
      { h: "How we use it", b: "We use your details only to respond to your enquiry or fulfil your order. We do not sell, rent or share your personal information with third parties for marketing." },
      { h: "Storage", b: "Enquiry details are stored securely and retained only as long as needed to handle your request and any follow-up." },
      { h: "Your choices", b: `You can ask us to view, correct or delete your information at any time by writing to ${CONTACT.email}.` },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "The plain-language terms for using this website.",
    sections: [
      { h: "The website", b: "This website is operated by ASAFU Consumer Goods for the PhudG brand. Product information, images and content are provided in good faith; we work to keep them accurate and up to date." },
      { h: "Products & pricing", b: "Prices shown are in Indian Rupees and may change without notice. Product availability may vary by size and channel. Lab reports published on this site are the actual third-party test reports for the respective products." },
      { h: "Orders", b: "Orders placed via WhatsApp are confirmed directly with you before fulfilment. Orders via Amazon or Instamart are governed by those platforms' terms." },
      { h: "Intellectual property", b: "All content on this site — text, design and imagery — belongs to ASAFU Consumer Goods and may not be reproduced without permission." },
    ],
  },
  shipping: {
    title: "Shipping Policy",
    intro: "How your oil gets to your kitchen.",
    sections: [
      { h: "Order channels", b: "PhudG oils are currently available through Amazon, Instamart and direct WhatsApp orders. Orders placed on marketplaces are shipped under those platforms' shipping policies and timelines." },
      { h: "WhatsApp orders", b: "For direct orders placed over WhatsApp, we confirm availability, delivery timeline and any shipping charges with you before dispatch." },
      { h: "Packaging", b: "Oils are bottled in glass and packed with protective material for transit. Please check the package on delivery." },
      { h: "Questions", b: `For any shipping query, write to ${CONTACT.email} or reach us on WhatsApp.` },
    ],
  },
  refunds: {
    title: "Cancellation & Refund Policy",
    intro: "Fair and simple, the way it should be.",
    sections: [
      { h: "Marketplace orders", b: "Orders placed on Amazon or Instamart are cancelled, returned and refunded under those platforms' policies — please use their app or support for the fastest resolution." },
      { h: "Direct (WhatsApp) orders", b: "If your order arrives damaged, leaking or incorrect, contact us within 48 hours of delivery with photographs at our WhatsApp number or email, and we will arrange a replacement or refund." },
      { h: "Cancellations", b: "Direct orders can be cancelled any time before dispatch — just message us on WhatsApp." },
      { h: "Contact", b: `${CONTACT.company}, ${CONTACT.address}. Email: ${CONTACT.email}.` },
    ],
  },
};

export default function LegalPage() {
  const { page } = useParams();
  const doc = LEGAL[page];

  return (
    <main data-testid={`legal-${page}-page`}>
      <Seo title={doc ? `${doc.title} | PhudG` : "Legal | PhudG"} description={doc ? doc.intro : ""} />
      <Header />
      <section className="bg-ink grain relative pt-36 pb-16 overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <p className="text-xs tracking-[0.4em] uppercase text-gold mb-4">Legal</p>
          <h1 className="font-serif text-4xl md:text-6xl text-cream tracking-tighter">{doc ? doc.title : "Page not found"}</h1>
          {doc && <p className="mt-5 max-w-xl text-base font-light text-cream/60">{doc.intro}</p>}
        </div>
      </section>
      <section className="bg-cream py-20 md:py-24">
        <div className="max-w-3xl mx-auto px-6">
          {doc ? (
            doc.sections.map((s, i) => (
              <div key={i} data-testid={`legal-section-${i}`} className="mb-10">
                <h2 className="font-serif text-2xl text-ink mb-3">{s.h}</h2>
                <p className="text-sm md:text-base font-light text-ink/60 leading-relaxed">{s.b}</p>
              </div>
            ))
          ) : (
            <p className="text-ink/60">
              This page doesn't exist. <Link to="/" className="text-amberbrand underline">Back home</Link>
            </p>
          )}
        </div>
      </section>
      <Footer />
    </main>
  );
}
